import { render } from "./ItemHeader.vue?vue&type=template&id=1fa9ff05"
import script from "./ItemHeader.vue?vue&type=script&lang=js"
export * from "./ItemHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__